<div *ngIf="isAllowed" class="container">
  <div class="vehicle-report">
    <div class="image-container" [ngClass]="dealerImageDetails?.url ? 'header-with-image':'header-without-image'">
      @if (dealerImageDetails?.url) {
        <img [src]="dealerImageDetails?.url" alt='File not Found' i18n-alt/>
      }
    </div>

    <mat-card class="report-card" [ngClass]="{ 'hide-dealer-image': dealerImageDisplay }" >
      @if (apiResponse) {
        <div class="report-header">
          <mat-card-title>{{apiResponse?.healthCheckReportDetails?.name}}</mat-card-title>
          <div class="download-container">
            <button class="download-button" mat-mini-fab color="primary" [disabled]="isDownloading" matTooltip='downloadPdf'
            i18n (click)="downloadPdf()">
            @if(!isDownloading && !downloadCompleted){
            <img #downloadPDFTour class="download-icon" src="../../assets/common/download-tray.svg"
                alt='File not found.' i18n-alt /> 
            }
              @if (isDownloading) {
                <mat-progress-spinner diameter="24" mode="indeterminate">
                </mat-progress-spinner>
              }
              @if (downloadCompleted) {
                <mat-icon class="completed-icon">check</mat-icon>
              }
            </button>
          </div>
        </div>
      }
      <mat-card-subtitle class="datetime">{{apiResponse?.healthCheckReportDetails?.submittedDate  | date:'dd.MM.yyyy'}}|{{apiResponse?.healthCheckReportDetails?.submittedDate | date:'h:mm a' | lowercase }}</mat-card-subtitle>
      <div>
       <button class="download-icon-large-screen" (click)="downloadPdf()">
           @if(!isDownloading && !downloadCompleted){
            <img src="../../assets/common/download-icon.png" class="icon" />
            <span class="download-text" i18n>Download report</span>
            }

            @if(isDownloading){
              <img src="../../assets/common/downloading (2).png" class="icon"/>
              <span class="download-text" i18n>Download report</span>
            }

            @if(downloadCompleted){
              <img src="../../assets/common/download_done.png" class="icon"/>
              <span class="download-text" i18n>Download report</span>
            }
          </button>
      </div>

      <!-- Vehicle Info Section -->
      <div class="section vehicle-info-section">
        <div class="vehicle-data">
          <p class="title" i18n>{{apiResponse?.healthCheckReportDetails?.order?.vehicle?.make}}
          {{apiResponse?.healthCheckReportDetails?.order?.vehicle?.model}}</p>
          <p class="subtitle">{{apiResponse?.healthCheckReportDetails?.order?.vehicle?.licenseNo}} |
          {{apiResponse?.healthCheckReportDetails?.order?.vehicle?.mileage}} miles</p>
        </div>
      </div>


      <!-- Issues Section -->
      <div class="section vehicle-info-section" (click)="navigateToIssues()" (keydown.enter)="navigateToIssues()">
        <div class="button-data">
          <p class="title" i18n>Issues</p>
          <p class="subtitle" i18n>{{criticalCount}} critical | {{cautionCount}} caution</p>
        </div>
        <button  mat-mini-fab color="primary" class="chevron-right">
          <div #pendingIssues>
            <mat-icon>chevron_right</mat-icon>
          </div>
        </button>
      </div>

      <!-- Checked & OK Section -->
      <div class="section vehicle-info-section" (click)="navigateToCheckedOk()" (keydown.enter)="navigateToCheckedOk()">
        <div class="button-data">
          <p class="title" i18n>Checked and OK</p>
          <p class="subtitle" i18n>{{checkedOkCount}} checkpoints</p>
          <mat-divider></mat-divider>
          @if (!isLargeScreen) {
            <a class="link" role="link" tabindex="0" (click)="navigateToPendingRequests($event)" (keydown.enter)="navigateToPendingRequests($event)" i18n>{{needAuthorization}} pending authorization requests</a>
          }
          @if (isLargeScreen) {
            <p class="subtitle" i18n>{{needAuthorization}} pending authorization requests</p>
          }
        </div>
        <button class="chevron-right" mat-mini-fab color="primary">
          <div #checkedOk>
            <mat-icon>chevron_right</mat-icon>
          </div>
        </button>
      </div>
    </mat-card>
  </div>

  <div class="seperator"></div>

  <!-- Auth Component (only for large screens) -->
  @if (isLargeScreen) {
    <div class="auth-section">
      <app-vvr-jobs-auth [apiResponse]="apiResponse" (updateChecklistData)="onChecklistUpdate()"></app-vvr-jobs-auth>
    </div>
  }
</div>

<div *ngIf="!isAllowed"></div>
